/**
 * Curve-level export column registry for the column-selection modal.
 * Mirrors the category structure in curveFeaturesVariableKey.js.
 */

export const CURVE_EXPORT_FEATURE_GROUPS = [
  {
    id: 'identifiers',
    label: 'Basic Identifiers',
    columns: [
      'subid', 'dataset_id', 'curve_id', 'curve_count', 'curve_threshold',
      'device_one_REGION', 'device_two_REGION', 'device_count_REGION'
    ]
  },
  {
    id: 'tac_curve',
    label: 'TAC Curve Features',
    columns: [
      'duration_CURVE', 'begin_CURVE', 'end_CURVE',
      'auc_total_CURVE', 'auc_relative_CURVE',
      'peak_CURVE', 'relative_peak_CURVE',
      'first_tac_CURVE', 'last_tac_CURVE',
      'mean_tac_CURVE', 'sd_tac_CURVE', 'sem_tac_CURVE'
    ]
  },
  {
    id: 'rise_phase',
    label: 'Rise Phase Features',
    columns: [
      'rise_duration_CURVE', 'rise_rate_CURVE',
      'rise_rate_point_to_point_CURVE', 'rise_duration_point_to_point_CURVE',
      'rise_rate_1hr_CURVE', 'rise_rate_2hr_CURVE',
      'rise_complete_percent_CURVE',
      'rise_imputed_percent_CURVE', 'ascending_imputed_percent_CURVE'
    ]
  },
  {
    id: 'fall_phase',
    label: 'Fall Phase Features',
    columns: [
      'fall_duration_CURVE', 'fall_rate_CURVE',
      'fall_rate_point_to_point_CURVE', 'fall_duration_point_to_point_CURVE',
      'fall_rate_1hr_CURVE', 'fall_rate_2hr_CURVE',
      'fall_complete_percent_CURVE',
      'fall_imputed_percent_CURVE', 'descending_imputed_percent_CURVE',
      'rise_fall_rate_CURVE', 'get_start_to_peak_interval_CURVE'
    ]
  },
  {
    id: 'curve_quality',
    label: 'Curve Quality',
    columns: [
      'total_duration_CURVE',
      'device_turned_on_duration_CURVE', 'device_turned_on_percent_CURVE',
      'device_worn_duration_CURVE', 'device_worn_percent_CURVE',
      'flatline_max_CURVE', 'flatlined_percent_CURVE',
      'high_quality_duration_CURVE', 'high_quality_percent_CURVE',
      'high_quality_above_threshold_duration_CURVE',
      'below_threshold_percent_CURVE',
      'started_curve_count_CURVE', 'complete_curve_count_CURVE'
    ]
  },
  {
    id: 'curve_imputation',
    label: 'Curve Imputation',
    columns: [
      'imputed_duration_CURVE', 'imputed_percent_CURVE',
      'imputed_low_quality_duration_CURVE', 'imputed_low_quality_percent_CURVE',
      'unimputed_low_quality_duration_CURVE', 'unimputed_low_quality_percent_CURVE',
      'total_low_quality_duration_CURVE', 'total_low_quality_percent_CURVE',
      'low_quality_imputation_ratio_CURVE'
    ]
  },
  {
    id: 'curve_gaps',
    label: 'Curve Gap Features',
    columns: [
      'imputed_gap_duration_CURVE', 'imputed_gap_percent_CURVE',
      'unimputed_gap_duration_CURVE', 'unimputed_gap_percent_CURVE',
      'total_gap_duration_CURVE', 'total_gap_percent_CURVE',
      'gap_imputation_ratio_CURVE'
    ]
  },
  {
    id: 'curve_non_wear',
    label: 'Curve Non-Wear Features',
    columns: [
      'imputed_non_wear_duration_CURVE', 'imputed_non_wear_percent_CURVE',
      'unimputed_non_wear_duration_CURVE', 'unimputed_non_wear_percent_CURVE',
      'total_non_wear_duration_CURVE', 'total_non_wear_percent_CURVE',
      'non_wear_imputation_ratio_CURVE',
      'total_gaps_and_non_wear_percent_CURVE',
      'unimputed_gaps_and_non_wear_percent_CURVE'
    ]
  },
  {
    id: 'curve_artifacts',
    label: 'Curve Artifact Features',
    columns: [
      'imputed_jump_duration_CURVE', 'imputed_jump_percent_CURVE',
      'unimputed_jump_duration_CURVE', 'unimputed_jump_percent_CURVE',
      'total_jump_duration_CURVE', 'total_jump_percent_CURVE',
      'jump_imputation_ratio_CURVE',
      'imputed_plummet_duration_CURVE', 'imputed_plummet_percent_CURVE',
      'unimputed_plummet_duration_CURVE', 'unimputed_plummet_percent_CURVE',
      'total_plummet_duration_CURVE', 'total_plummet_percent_CURVE',
      'plummet_imputation_ratio_CURVE',
      'imputed_extreme_negative_duration_CURVE', 'imputed_extreme_negative_percent_CURVE',
      'unimputed_extreme_negative_duration_CURVE', 'unimputed_extreme_negative_percent_CURVE',
      'total_extreme_negative_duration_CURVE', 'total_extreme_negative_percent_CURVE',
      'sub_negative_10_sum_CURVE',
      'extreme_negative_imputation_ratio_CURVE'
    ]
  },
  {
    id: 'periphery_before',
    label: 'Periphery Before Quality',
    columns: [
      'total_duration_PERIPHERY_BEFORE',
      'device_turned_on_duration_PERIPHERY_BEFORE', 'device_turned_on_percent_PERIPHERY_BEFORE',
      'device_worn_duration_PERIPHERY_BEFORE', 'device_worn_percent_PERIPHERY_BEFORE',
      'imputed_duration_PERIPHERY_BEFORE', 'imputed_percent_PERIPHERY_BEFORE',
      'imputed_low_quality_duration_PERIPHERY_BEFORE', 'imputed_low_quality_percent_PERIPHERY_BEFORE',
      'unimputed_low_quality_duration_PERIPHERY_BEFORE', 'unimputed_low_quality_percent_PERIPHERY_BEFORE',
      'total_low_quality_duration_PERIPHERY_BEFORE', 'total_low_quality_percent_PERIPHERY_BEFORE',
      'imputed_gap_duration_PERIPHERY_BEFORE', 'imputed_gap_percent_PERIPHERY_BEFORE',
      'unimputed_gap_duration_PERIPHERY_BEFORE', 'unimputed_gap_percent_PERIPHERY_BEFORE',
      'total_gap_duration_PERIPHERY_BEFORE', 'total_gap_percent_PERIPHERY_BEFORE',
      'gap_imputation_ratio_PERIPHERY_BEFORE',
      'imputed_non_wear_duration_PERIPHERY_BEFORE', 'imputed_non_wear_percent_PERIPHERY_BEFORE',
      'unimputed_non_wear_duration_PERIPHERY_BEFORE', 'unimputed_non_wear_percent_PERIPHERY_BEFORE',
      'total_non_wear_duration_PERIPHERY_BEFORE', 'total_non_wear_percent_PERIPHERY_BEFORE',
      'non_wear_imputation_ratio_PERIPHERY_BEFORE',
      'imputed_jump_duration_PERIPHERY_BEFORE', 'imputed_jump_percent_PERIPHERY_BEFORE',
      'unimputed_jump_duration_PERIPHERY_BEFORE', 'unimputed_jump_percent_PERIPHERY_BEFORE',
      'total_jump_duration_PERIPHERY_BEFORE', 'total_jump_percent_PERIPHERY_BEFORE',
      'jump_imputation_ratio_PERIPHERY_BEFORE',
      'imputed_plummet_duration_PERIPHERY_BEFORE', 'imputed_plummet_percent_PERIPHERY_BEFORE',
      'unimputed_plummet_duration_PERIPHERY_BEFORE', 'unimputed_plummet_percent_PERIPHERY_BEFORE',
      'total_plummet_duration_PERIPHERY_BEFORE', 'total_plummet_percent_PERIPHERY_BEFORE',
      'plummet_imputation_ratio_PERIPHERY_BEFORE',
      'imputed_extreme_negative_duration_PERIPHERY_BEFORE', 'imputed_extreme_negative_percent_PERIPHERY_BEFORE',
      'unimputed_extreme_negative_duration_PERIPHERY_BEFORE', 'unimputed_extreme_negative_percent_PERIPHERY_BEFORE',
      'total_extreme_negative_duration_PERIPHERY_BEFORE', 'total_extreme_negative_percent_PERIPHERY_BEFORE',
      'sub_negative_10_sum_PERIPHERY_BEFORE',
      'extreme_negative_imputation_ratio_PERIPHERY_BEFORE',
      'low_quality_imputation_ratio_PERIPHERY_BEFORE',
      'total_gaps_and_non_wear_percent_PERIPHERY_BEFORE'
    ]
  },
  {
    id: 'periphery_after',
    label: 'Periphery After Quality',
    columns: [
      'total_duration_PERIPHERY_AFTER',
      'device_turned_on_duration_PERIPHERY_AFTER', 'device_turned_on_percent_PERIPHERY_AFTER',
      'device_worn_duration_PERIPHERY_AFTER', 'device_worn_percent_PERIPHERY_AFTER',
      'imputed_duration_PERIPHERY_AFTER', 'imputed_percent_PERIPHERY_AFTER',
      'imputed_low_quality_duration_PERIPHERY_AFTER', 'imputed_low_quality_percent_PERIPHERY_AFTER',
      'unimputed_low_quality_duration_PERIPHERY_AFTER', 'unimputed_low_quality_percent_PERIPHERY_AFTER',
      'total_low_quality_duration_PERIPHERY_AFTER', 'total_low_quality_percent_PERIPHERY_AFTER',
      'imputed_gap_duration_PERIPHERY_AFTER', 'imputed_gap_percent_PERIPHERY_AFTER',
      'unimputed_gap_duration_PERIPHERY_AFTER', 'unimputed_gap_percent_PERIPHERY_AFTER',
      'total_gap_duration_PERIPHERY_AFTER', 'total_gap_percent_PERIPHERY_AFTER',
      'gap_imputation_ratio_PERIPHERY_AFTER',
      'imputed_non_wear_duration_PERIPHERY_AFTER', 'imputed_non_wear_percent_PERIPHERY_AFTER',
      'unimputed_non_wear_duration_PERIPHERY_AFTER', 'unimputed_non_wear_percent_PERIPHERY_AFTER',
      'total_non_wear_duration_PERIPHERY_AFTER', 'total_non_wear_percent_PERIPHERY_AFTER',
      'non_wear_imputation_ratio_PERIPHERY_AFTER',
      'imputed_jump_duration_PERIPHERY_AFTER', 'imputed_jump_percent_PERIPHERY_AFTER',
      'unimputed_jump_duration_PERIPHERY_AFTER', 'unimputed_jump_percent_PERIPHERY_AFTER',
      'total_jump_duration_PERIPHERY_AFTER', 'total_jump_percent_PERIPHERY_AFTER',
      'jump_imputation_ratio_PERIPHERY_AFTER',
      'imputed_plummet_duration_PERIPHERY_AFTER', 'imputed_plummet_percent_PERIPHERY_AFTER',
      'unimputed_plummet_duration_PERIPHERY_AFTER', 'unimputed_plummet_percent_PERIPHERY_AFTER',
      'total_plummet_duration_PERIPHERY_AFTER', 'total_plummet_percent_PERIPHERY_AFTER',
      'plummet_imputation_ratio_PERIPHERY_AFTER',
      'imputed_extreme_negative_duration_PERIPHERY_AFTER', 'imputed_extreme_negative_percent_PERIPHERY_AFTER',
      'unimputed_extreme_negative_duration_PERIPHERY_AFTER', 'unimputed_extreme_negative_percent_PERIPHERY_AFTER',
      'total_extreme_negative_duration_PERIPHERY_AFTER', 'total_extreme_negative_percent_PERIPHERY_AFTER',
      'sub_negative_10_sum_PERIPHERY_AFTER',
      'extreme_negative_imputation_ratio_PERIPHERY_AFTER',
      'low_quality_imputation_ratio_PERIPHERY_AFTER',
      'total_gaps_and_non_wear_percent_PERIPHERY_AFTER'
    ]
  },
  {
    id: 'region_quality',
    label: 'Region Quality Features',
    columns: [
      'started_curve_count_REGION', 'complete_curve_count_REGION',
      'total_duration_REGION',
      'device_turned_on_duration_REGION', 'device_turned_on_percent_REGION',
      'device_worn_duration_REGION', 'device_worn_percent_REGION',
      'flatline_max_REGION', 'flatlined_percent_REGION',
      'imputed_duration_REGION', 'imputed_percent_REGION',
      'imputed_low_quality_duration_REGION', 'imputed_low_quality_percent_REGION',
      'unimputed_low_quality_duration_REGION', 'unimputed_low_quality_percent_REGION',
      'total_low_quality_duration_REGION', 'total_low_quality_percent_REGION',
      'imputed_gap_duration_REGION', 'imputed_gap_percent_REGION',
      'unimputed_gap_duration_REGION', 'unimputed_gap_percent_REGION',
      'total_gap_duration_REGION', 'total_gap_percent_REGION',
      'gap_imputation_ratio_REGION',
      'imputed_non_wear_duration_REGION', 'imputed_non_wear_percent_REGION',
      'unimputed_non_wear_duration_REGION', 'unimputed_non_wear_percent_REGION',
      'total_non_wear_duration_REGION', 'total_non_wear_percent_REGION',
      'non_wear_imputation_ratio_REGION',
      'imputed_jump_duration_REGION', 'imputed_jump_percent_REGION',
      'unimputed_jump_duration_REGION', 'unimputed_jump_percent_REGION',
      'total_jump_duration_REGION', 'total_jump_percent_REGION',
      'jump_imputation_ratio_REGION',
      'imputed_plummet_duration_REGION', 'imputed_plummet_percent_REGION',
      'unimputed_plummet_duration_REGION', 'unimputed_plummet_percent_REGION',
      'total_plummet_duration_REGION', 'total_plummet_percent_REGION',
      'plummet_imputation_ratio_REGION',
      'imputed_extreme_negative_duration_REGION', 'imputed_extreme_negative_percent_REGION',
      'unimputed_extreme_negative_duration_REGION', 'unimputed_extreme_negative_percent_REGION',
      'total_extreme_negative_duration_REGION', 'total_extreme_negative_percent_REGION',
      'sub_negative_10_sum_REGION',
      'extreme_negative_imputation_ratio_REGION',
      'low_quality_imputation_ratio_REGION',
      'total_gaps_and_non_wear_percent_REGION'
    ]
  },
  {
    id: 'curve_flags',
    label: 'Curve Flags',
    columns: [
      'FLAG_unimputed_low_quality_curve',
      'FLAG_imputed_limit_curve',
      'FLAG_unimputed_jump_curve',
      'FLAG_below_threshold_curve',
      'FLAG_flat_curve',
      'FLAG_incomplete_curve_start_curve',
      'FLAG_incomplete_periphery_before_curve',
      'FLAG_imputed_rise_curve',
      'FLAG_incomplete_curve_end_curve',
      'FLAG_incomplete_periphery_after_curve',
      'FLAG_imputed_fall_curve'
    ]
  },
  {
    id: 'periphery_flags',
    label: 'Periphery Flags',
    columns: [
      'FLAG_gaps_and_non_wear_periphery_before',
      'FLAG_extreme_negative_periphery_before',
      'FLAG_unimputed_low_quality_periphery_before',
      'FLAG_gaps_and_non_wear_periphery_after',
      'FLAG_extreme_negative_periphery_after',
      'FLAG_unimputed_low_quality_periphery_after'
    ]
  },
  {
    id: 'validity',
    label: 'Validity Indicators',
    columns: ['CURVE_VALID', 'PERIPHERY_VALID', 'REGION_VALID']
  },
  {
    id: 'baseline',
    label: 'Baseline Information',
    columns: ['unadjusted_threshold', 'baseline_mean', 'baseline_sd']
  }
]

function allRegisteredColumns() {
  return CURVE_EXPORT_FEATURE_GROUPS.flatMap((g) => g.columns)
}

/** Columns included in the "Essential" preset — identifiers + core TAC metrics + validity. */
const ESSENTIAL_CURVE_COLUMNS = new Set([
  'subid', 'dataset_id', 'curve_id', 'curve_count', 'curve_threshold',
  'duration_CURVE', 'begin_CURVE', 'end_CURVE',
  'auc_total_CURVE', 'auc_relative_CURVE',
  'peak_CURVE', 'relative_peak_CURVE',
  'rise_duration_CURVE', 'rise_rate_CURVE',
  'fall_duration_CURVE', 'fall_rate_CURVE',
  'device_worn_percent_CURVE',
  'total_low_quality_percent_CURVE',
  'total_gaps_and_non_wear_percent_CURVE',
  'CURVE_VALID', 'PERIPHERY_VALID', 'REGION_VALID'
])

/** Groups included in the "Defaults" preset — everything except periphery detail & artifacts. */
const DEFAULT_OFF_GROUPS = new Set([
  'periphery_before', 'periphery_after', 'region_quality',
  'curve_imputation', 'curve_gaps', 'curve_non_wear', 'curve_artifacts'
])

export function buildEssentialCurveExportColumns() {
  const map = {}
  for (const col of allRegisteredColumns()) {
    map[col] = ESSENTIAL_CURVE_COLUMNS.has(col)
  }
  return map
}

export function buildDefaultCurveExportColumns() {
  const map = {}
  for (const group of CURVE_EXPORT_FEATURE_GROUPS) {
    const on = !DEFAULT_OFF_GROUPS.has(group.id)
    for (const col of group.columns) {
      map[col] = on
    }
  }
  return map
}

export function buildAllCurveExportColumns() {
  const map = {}
  for (const col of allRegisteredColumns()) {
    map[col] = true
  }
  return map
}

/**
 * Flat description lookup built from curveFeaturesVariableKey.featureCategories.
 * Imported lazily so the variable-key module stays the single source of truth.
 */
export function buildCurveDescriptions(featureCategories) {
  const descs = {}
  for (const features of Object.values(featureCategories)) {
    for (const [key, desc] of Object.entries(features)) {
      descs[key] = desc
    }
  }
  return descs
}
